import { SearchItemAttribute } from 'types/models/SearchItemAttribute';
import Attribute from 'types/Attribute';

export const getMappedAttributes = (attributes: SearchItemAttribute[]): Attribute[] =>
  attributes.map((attribute, i) => ({
    id: i,
    name: attribute.name,
    value: typeof attribute.value === 'string' ? [attribute.value] : attribute.value?.values || [''],
    attributes: [],
  }));
